import { FC } from 'react';

import { Grid, Typography } from '@mui/material';
import clsx from 'clsx';

import { LOOK } from 'components/_basic/TotalSumInput';

import { concatWithDot } from 'helpers/string';

import { IReadOnlyTableRowProps } from './types';
import { ReadOnlyInputField } from '../ReadOnlyInputField';

import styles from './ReadOnlyTableRow.module.scss';

export const ReadOnlyTableRow: FC<IReadOnlyTableRowProps> = ({
  columnValues,
  rowTitle,
  firstColumnWidth,
  name,
  rowIndex,
  noNeedName = false,
  disabled = false,
  allowNegative = true,
}) => {
  return (
    <Grid container className={styles.container} wrap="nowrap" gap={2}>
      <Grid item sx={{ width: firstColumnWidth }} className={styles.sticky}>
        <Typography variant="subtitle2" className={clsx(styles.title, { [styles.disabled]: disabled })}>
          {rowTitle}
        </Typography>
      </Grid>
      <Grid item xs>
        <Grid container spacing={1} columns={columnValues.length} wrap="nowrap">
          {columnValues.map((value, index) => {
            const fieldName = concatWithDot(name, `${rowIndex}.${index}`);
            return (
              <Grid key={index} item xs={1}>
                <ReadOnlyInputField
                  value={value}
                  look={LOOK.DEFAULT}
                  className={styles.tableRow}
                  name={!noNeedName ? fieldName : ''}
                  id={!noNeedName ? fieldName : ''}
                  decimalScale={1}
                  allowNegative={allowNegative}
                />
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Grid>
  );
};
